import { createFileRoute, Outlet } from "@tanstack/react-router";
import { guardConsole } from "@/lib/route-guard";

export const Route = createFileRoute("/_authenticated/super-admin")({
  beforeLoad: guardConsole("super_admin"),
  component: () => <Outlet />,
});
